export const LEGAL_MENU_IDENTIFIER = 'legal';
export const FOR_CLIENTS_MENU_IDENTIFIER = 'for-clients';
export const COMPANY_MENU_IDENTIFIER = 'company';
export const MAIN_MENU_IDENTIFIER = 'main';
